import StvJaNeinUnbekannt from "./StvJaNeinUnbekannt";

export default class HundDto {
    name?: string;

    rasse?: string;

    rasseVersicherbar?: StvJaNeinUnbekannt;
}